// extracted by mini-css-extract-plugin
module.exports = {"Preview":"PostForm_Preview__EEIWe"};